<template>
  <div class="form-group has-feedback" :class="{'has-error': error}" style="margin-bottom: 0">
    <label :for=uniq class="control-label" :class="'col-sm-'+labelSize">{{label}}</label>

    <div :class="'col-sm-'+size">
      <textarea class="form-control" :name=name :id=uniq @change='$emit("update:modelValue", $event.target.value)' >{{modelValue}}</textarea>
      <span class="help-block">{{error}}</span>
    </div>
    <Icon v-if="info" name="fa-info-circle" :title=info />
        
    <slot></slot>
  </div>
</template>

<script>

import _ from "underscore"

export default {
  name: "Input",
  
  data()
  {
    return { 
       uniq: null,
    }
  },
  
  emits: [ 'update:modelValue' ],
  
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    size: {
      type: Number,
      default: 6,
    },
    modelValue: {
       type: String,
    },
    labelSize: {
      type: Number,
      default: 3,
    },
    error: {
      type: String,
    },
    info: {
      type: String,
    },
  },
  
  mounted()
  {
    this.uniq = _.uniqueId("textarea")
  },
}
</script>
